import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { PageHeaderInlineEdit } from 'ui/inlineEdit';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';

import { useEditCriteria } from '../hooks/useEditCriteria';
import { CRITERIA_NAME_MAX_LENGTH, TOAST_ACTIONS } from '../constants';
import { useQueryAnonCriteria } from '../hooks/useQueryAnonCriteria';

export const AnonCriteriaName = ({ setIsEditingName }: any) => {
  const dispatch = useDispatch();
  const { editCriteria } = useEditCriteria();
  const { id } = useParams<{ id: string }>();
  const criteriaId = parseInt(id, 10);

  const { criteria } = useQueryAnonCriteria(criteriaId);
  const [criteriaNameInput, setCriteriaNameInput] = useState(criteria?.fields.name || '');

  useEffect(() => setCriteriaNameInput(criteria?.fields.name || ''), [criteria]);

  const handleEditName = () => {
    if (criteriaNameInput === criteria?.fields.name) {
      setIsEditingName(false);
      return;
    }
    if (!criteriaNameInput) {
      setCriteriaNameInput(criteria?.fields.name || '');
      setIsEditingName(false);
      return;
    }
    editCriteria({
      variables: {
        id: criteriaId,
        criteria: {
          ...criteria?.fields,
          name: criteriaNameInput,
        },
      },
      onCompleted: () => dispatch(addPositiveToast('Criteria name updated successfully.')),
      onError: (e) =>
        dispatch(
          addNegativeToastWithErrorId('Unable to save criteria name.', TOAST_ACTIONS.editName, e),
        ),
    });
    setIsEditingName(false);
  };

  return (
    <PageHeaderInlineEdit
      showTooltipWhenOverflow
      onBlur={handleEditName}
      onChange={setCriteriaNameInput}
      value={criteriaNameInput}
      maxLength={CRITERIA_NAME_MAX_LENGTH}
    />
  );
};
